// Generic imports
import React, { useState } from "react"
import styled from "styled-components"
import { toast } from "react-toastify"

// Other components imports
import Button from "components/Button"

import blankProfile from "images/blank-profile.png"

import { invitePengajar, removePengajar } from "services/kelas"

const Styles = styled.div`
  .invitation-wrapper {
    display: flex;
    align-items: center;
    padding-bottom: 12px;
    margin-bottom: 4px;
    border-bottom: 1px solid #cacccf;

    .invitation-status {
      margin-left: 10px;
      margin-right: 10px;
    }
  }

  .invite-pengajar {
    display: flex;

    input {
      margin-right: 10px;
    }
  }
`

export default function JadwalMaker(props) {
  const { kelas, updateKelas, isEdit } = props
  const [loading, setLoading] = useState(false)
  const [emails, setEmails] = useState("")

  const submitInvite = async () => {
    try {
      setLoading(true)
      let errors = 0
      await Promise.all(
        emails.split(",").map(async email => {
          try {
            email = email.trim()
            const data = {
              kelas: kelas.id,
              tutor: email,
            }
            await invitePengajar(data)
          } catch (e) {
            errors += 1
            if (e.response.data?.detail === "Tutor does not exist.") {
              toast.error(`${email} does not exist/not registered as tutor`)
            } else {
              toast.error(`Failed inviting ${email}`)
            }
          }
        })
      )
      if (errors !== emails.split(",").length) {
        toast.success("Success editing tutor(s)")
        setTimeout(() => {
          toast.success("Updating data...")
        }, 2000)
      }
    } catch (e) {
      toast.error(e.response.data ? e.response.data : "Please try again later")
    } finally {
      setTimeout(() => {
        updateKelas()
        setLoading(false)
      }, 3000)
    }
  }

  const removeTutor = async id => {
    try {
      await removePengajar(id)
      toast.success("Success editing tutor(s)")
      setTimeout(() => {
        toast.success("Updating data...")
      }, 2000)
    } catch (e) {
      toast.error(e.response.data ? e.response.data : "Please try again later")
    } finally {
      setTimeout(() => {
        updateKelas()
        setLoading(false)
      }, 3000)
    }
  }

  return (
    <Styles>
      {kelas.kelas_tutor?.map(({ tutor, status, id }, index) => (
        <div className="pengajar-baris" key={index}>
          <div
            className="pengajar-left"
            style={
              tutor.pengguna.photo
                ? { backgroundImage: `url(${tutor.pengguna.photo})` }
                : { backgroundImage: `url(${blankProfile})` }
            }
          ></div>
          <div className="pengajar-right">
            <div className="invitation-wrapper">
              <Button
                className="secondary"
                type="button"
                onClick={() => removeTutor(id)}
              >
                Remove
              </Button>
              <div className="invitation-status">
                Invitation status:{" "}
                {status === "2" ? (
                  <span style={{ color: "#51b848" }}>Accepted</span>
                ) : (
                  <span style={{ color: "#eccb45" }}>Pending</span>
                )}
              </div>
            </div>
            <h4>
              {tutor.pengguna.first_name + " " + tutor.pengguna.last_name}
            </h4>
            <h5>{tutor.role}</h5>
            <div>{tutor.description}</div>
            {tutor.portofolio_link ? (
              <div className="pt-2">
                Link Portfolio:
                <a href={tutor.portofolio_link}> {tutor.portofolio_link}</a>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      ))}
      {isEdit ? (
        <>
          <h5>Invite Pengajar</h5>
          <div className="invite-pengajar">
            <input
              id="tutorlist"
              name="tutorlist"
              type="text"
              placeholder="tutor1@gmail.com, tutor2@gmail.com, tutor3@gmail.com"
              onChange={e => setEmails(e.target.value)}
              value={emails}
            />
            <Button
              disabled={loading || !isEdit}
              onClick={submitInvite}
              type="button"
            >
              {loading ? "Inviting..." : "Invite"}
            </Button>
          </div>
        </>
      ) : (
        <div style={{ paddingBottom: "12px" }}>
          Invite tutor(s) available after you published the class
        </div>
      )}
    </Styles>
  )
}
